import { useMutation } from '@tanstack/react-query'
import { authApi } from '../api/auth.api'

interface VerifyOTPParams {
    identifier: string
    otpCode: string
    purpose: 'SIGNUP' | 'LOGIN' | 'MFA' | 'PASSWORD_RESET'
}

export function useVerifyOTP() {
    return useMutation({
        mutationFn: ({ identifier, otpCode, purpose }: VerifyOTPParams) =>
            authApi.verifyOTP(identifier, otpCode, purpose),
    })
}
